var map = {
	"./三花猫.jpeg": 1464,
	"./中国狸花猫.jpeg": 3433,
	"./俄罗斯蓝猫.jpeg": 5113,
	"./喜马拉雅猫.jpeg": 4500,
	"./四川简州猫.jpeg": 9420,
	"./土耳其安哥拉猫.jpeg": 8077,
	"./孟加拉猫.jpeg": 3646,
	"./山东狮子猫.jpeg": 1535,
	"./布偶猫.jpeg": 4881,
	"./异国短毛猫.jpeg": 1785,
	"./德文卷毛猫.jpeg": 6946,
	"./挪威森林猫.jpeg": 5684,
	"./斯芬克斯猫.jpeg": 861,
	"./暹罗猫.jpeg": 5942,
	"./曼基康猫.jpeg": 801,
	"./波斯猫.jpeg": 4087,
	"./玄猫.jpeg": 140,
	"./缅因猫.jpeg": 8229,
	"./美国卷耳猫.jpeg": 1188,
	"./美国短毛猫.jpeg": 3954,
	"./苏格兰折耳猫.jpeg": 3112,
	"./英国短毛猫.jpeg": 380,
	"./西伯利亚猫.jpeg": 7433,
	"./阿比西尼亚猫.jpeg": 4434,
	"./黄狸猫.jpeg": 6382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7874;